import React, { Component, useState } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import 'antd-mobile/dist/antd-mobile.css';

import "./SearchFuzzyIndex.css";
import {
    BulbOutlined,
    ColumnHeightOutlined,
    EnvironmentOutlined,
    FireOutlined,
    GoldOutlined,
    HomeOutlined,
    HourglassOutlined,
    ImportOutlined,
    InsuranceOutlined,
    OneToOneOutlined,
    ThunderboltOutlined
} from '@ant-design/icons';

import { Button, TextField, Divider } from '@material-ui/core';
import {
    getAddressItemListRenderInfo,
    handleClickAddressItem, refreshFuzzyBampResultList,
    refreshSearchCondition, searchMapZoneList, searchZoneListView
} from "../../../../actions/ZoneAction";
import { FuzzySearchType } from "../../../../Enums";
import { RoutePath } from '../../../../../../constants/RoutePath';
import { homeSearchApi } from '../../../../WebService';
import HttpUtils from '../../../../../../utils/HttpUtils';
import debounce from 'lodash.debounce';
import { Input, message } from 'antd';
import { CACHE_SESSION_USER } from '../../../../../../constants/Profile';

const DetailIndex = ({ dispatch, router, searchCondition, cityName, searchFuzzyBampResultList, brandList, districtTownList }) => {

    const [searchResult, setSearchResult] = useState({})
    const [searchKey, setSearchKey] = useState('')

    const brandClick = (item) => {

        let searchCondition = Object.assign({}, searchCondition);
        searchCondition = {
            ...searchCondition,
            town: '',
            brandId: item.id,
            brandName: item.nameZh1,
            fuzzy: item.nameZh1,
            searchFuzzyInfo: item.nameZh1,
            searchFuzzyType: FuzzySearchType.Enums.Brand,
            mapFuzzy: '', // 目标位置输入的关键词
            mapSearchRange: null,
            rectangleCenterPointLng: null,
            rectangleCenterPointLat: null,
        }
        dispatch(refreshSearchCondition(searchCondition));
        _handleDoSearch()
    }

    const townClick = (item) => {
        let searchCondition = Object.assign({}, searchCondition);
        searchCondition = {
            ...searchCondition,
            brandId: '',
            brandName: '',
            town: item.town,
            fuzzy: item.town,
            searchFuzzyInfo: item.town,
            searchFuzzyType: FuzzySearchType.Enums.Town,
            mapFuzzy: '', // 目标位置输入的关键词
            mapSearchRange: null,
            rectangleCenterPointLng: null,
            rectangleCenterPointLat: null,
        }
        dispatch(refreshSearchCondition(searchCondition));
        _handleDoSearch()
    }

    const changeTownClick = (item) => {

        let searchCondition = Object.assign({}, searchCondition);
        searchCondition = {
            ...searchCondition,
            brandId: '',
            brandName: '',
            town: item.town,
            fuzzy: item.town,
            searchFuzzyInfo: item.town,
            searchFuzzyType: FuzzySearchType.Enums.Town,
            mapFuzzy: '', // 目标位置输入的关键词
            mapSearchRange: null,
            rectangleCenterPointLng: null,
            rectangleCenterPointLat: null,
        }
        dispatch(refreshSearchCondition(searchCondition));
        _handleDoSearch()

    }

    const _handleDoSearch = (searchCondition) => {
        router.navigate(RoutePath.WMS_ZONE_LIST.path);
    }

    //输入时，根据输入信息，查询地图地址
    const _handleSearchAddress = debounce((fuzzy = '') => {
        fuzzy = fuzzy.trim()
        setSearchKey(fuzzy)
        //暂存关键字
        if (!cityName) {
            return message.error('请去首页选择城市')
        }
        if (fuzzy) {
            HttpUtils.post(homeSearchApi, {
                cityName: cityName,
                searchContent: fuzzy,
            }, (res) => {
                setSearchResult(res.data)
                // const searchCondition = Object.assign({}, searchCondition);
                // searchCondition.fuzzy = fuzzy;
                // //清除距离范围
                // searchCondition.mapSearchRange = undefined;
                // dispatch(refreshSearchCondition(searchCondition));

            })
        } else {
            setSearchResult([])
            // const searchCondition = Object.assign({}, searchCondition);
            // searchCondition.fuzzy = fuzzy;
            // //清除距离范围
            // searchCondition.mapSearchRange = undefined;
            // dispatch(refreshSearchCondition(searchCondition));
        }
    }, 300)

    return <div className='search-condition-fuzzy-page'>
        <div className="search-condition-fuzzy-input-container">

            <Input
                className="search-condition-fuzzy-input"
                autoFocus={true}
                onChange={(e) => {
                    _handleSearchAddress(e.target.value)
                }}
                placeholder="请输入品牌/子市场-乡镇"
            />
            <Button className="search-condition-fuzzy-cancel-button"
                onClick={() => {
                    _handleDoSearch()
                }}>取消</Button>
        </div>

        <div className='search-condition-fuzzy-list'>
            {searchResult.hasResult === true && (
                <>
                    <div>
                        {searchResult.currentCityBrands &&
                            searchResult.currentCityBrands.length > 0 && (
                                <>
                                    <div>
                                        开发商品牌
                                    </div>
                                    {searchResult.currentCityBrands.map((item, index) => {
                                        return (
                                            <div
                                                key={index}
                                                className='fuzzy-list-item city-list'
                                                onClick={() => brandClick(item)}
                                            >
                                                <div className="fuzzy-list-item-show-icon">
                                                    <img src={require("../../../../../../images/searchCondition/品牌.svg")} />
                                                </div>
                                                <div className="fuzzy-list-item-show-title">
                                                    <span>{item.nameZh1}</span>
                                                </div>
                                                <div className="fuzzy-list-item-show-type" >
                                                    <span>品牌</span>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </>
                            )}
                    </div>
                    <div>
                        {searchResult.currentCityTowns &&
                            searchResult.currentCityTowns.length > 0 && (
                                <>
                                    <div >
                                        子市场-乡镇
                                    </div>
                                    {searchResult.currentCityTowns.map((item, index) => {
                                        return (
                                            <div
                                                key={index}
                                                className='fuzzy-list-item city-list'
                                                onClick={() => townClick(item)}
                                            >
                                                <div className="fuzzy-list-item-show-icon">
                                                    <img src={require("../../../../../../images/searchCondition/所属乡镇.svg")} />
                                                </div>
                                                <div className="fuzzy-list-item-show-title">
                                                    <span>{item.district} - {item.town}</span>
                                                </div>
                                                <div className="fuzzy-list-item-show-type" >
                                                    <span>子市场-乡镇</span>
                                                </div>

                                            </div>
                                        )
                                    })}
                                </>
                            )}
                    </div>
                </>
            )}


            {searchResult.hasResult === false && (
                <>
                    <div className='border-0 border-b border-solid border-[#eee] px-5 py-2 text-sm font-bold'>
                        抱歉，当前城市查询结果无“{searchKey}”。
                    </div>
                    <div>
                        {searchResult.otherCityTowns &&
                            searchResult.otherCityTowns.length > 0 && (
                                <>
                                    <div className=''>
                                        其他城市查询结果
                                    </div>
                                    {searchResult.otherCityTowns.map((item, index) => {
                                        return (
                                            <div
                                                key={index}
                                                className='fuzzy-list-item city-list'
                                                onClick={() => changeTownClick(item)}
                                            >
                                                <div className="fuzzy-list-item-show-icon">
                                                    <img src={require("../../../../../../images/searchCondition/warehouse_icon.svg")} />
                                                </div>
                                                <div className="fuzzy-list-item-show-title">
                                                    <span>{item.district} - {item.town}</span>
                                                </div>
                                                <div className="fuzzy-list-item-show-type" >
                                                    <span>子市场-乡镇</span>
                                                </div>


                                            </div>
                                        )
                                    })}
                                </>
                            )}
                    </div>
                </>
            )}



        </div>


    </div>
}



function mapStateToProps(store) {
    return {
        inList: store.WMSZoneReducer.searchCondition,
        searchCondition: store.WMSZoneReducer.searchCondition,
        cityName: store.WMSZoneReducer.cityName,
        mapSearchConditionList: store.WMSZoneReducer.mapSearchConditionList,
        brandList: store.WMSZoneReducer.brandList,
        districtTownList: store.WMSZoneReducer.districtTownList,
        searchFuzzyBampResultList: store.WMSZoneReducer.searchFuzzyBampResultList,
    }
}

export default connect(mapStateToProps)(injectIntl(DetailIndex));